<template>
  <b-jumbotron>
    <template slot="header">
      MathMaker
    </template>
    <template slot="lead">
      Randomly generated maths exercises for teachers to share with children.
      <br>
      Aimed at UK Key Stage 1 and 2.
    </template>
    <hr>
    <p>
      Entire project made personally with all features designed and implemented by <a href="https://mcklatch.com/hi" rel="noopener noreferrer" target="_blank">David McClatchey</a>.
      <br>
      Made to the specifications of the final project assignment at <a href="http://cs50.tv/2016/fall/" rel="noopener noreferrer" target="_blank">Harvard CS50</a> 2016.
    </p>
    <b-btn variant="primary" to="/form">Get Started</b-btn>
  </b-jumbotron>
</template>

<script>
export default {
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue